import {connect} from 'react-redux';
import navigate from 'Data/actionCreators/kiosk/navigate';
import setJourneyStop from 'Data/actionCreators/journey/setJourneyStop';
import getEvents from 'Data/selectors/getEvents';
import setTakeMeThereEventId from 'Data/actionCreators/explorer/setTakeMeThereEventId';
import setSearchLocation from 'Data/actionCreators/journey/setSearchLocation';
import EventsList from './EventsList';

const mapStateToProps = state => ({
    events: getEvents(state),
    isExperiences: true,
    showHeader: false,
});

export default connect(
    mapStateToProps,
    {navigate, setJourneyStop, setSearchLocation, setTakeMeThereEventId}
)(EventsList);
